/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const InfoIcon = (props: SvgIconProps) => (
  <svg width="57" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="6" stroke="#4D4D4D" />
    <path
      d="M8.33366 4.99935C8.33366 5.18344 8.18442 5.33268 8.00033 5.33268C7.81623 5.33268 7.66699 5.18344 7.66699 4.99935C7.66699 4.81525 7.81623 4.66602 8.00033 4.66602C8.18442 4.66602 8.33366 4.81525 8.33366 4.99935Z"
      fill="#4D4D4D"
      stroke="#4D4D4D"
    />
    <path d="M8 11.3327V6.66602" stroke="#4D4D4D" />
  </svg>
);
export default InfoIcon;
